import React, { forwardRef } from "react";
import PhoneInput from "react-phone-number-input";
import { cn } from "@/lib/utils";
import 'react-phone-number-input/style.css';
import './international-phone-input.css';

export interface InternationalPhoneInputProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  autoFocus?: boolean;
}

const InternationalPhoneInput = forwardRef<any, InternationalPhoneInputProps>(
  ({ value, onChange, placeholder = "Numéro de téléphone", disabled, className, onKeyDown, autoFocus }, ref) => {
    return (
      <div className={cn("international-phone-input", className)}>
        <PhoneInput
          ref={ref}
          international
          countryCallingCodeEditable={false}
          defaultCountry="FR"
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
        />
      </div>
    );
  }
);

InternationalPhoneInput.displayName = "InternationalPhoneInput";

export { InternationalPhoneInput };